import { render, staticRenderFns } from "./SuppliesDetailView.vue?vue&type=template&id=f2e8d38c"
import script from "./SuppliesDetailView.vue?vue&type=script&lang=js"
export * from "./SuppliesDetailView.vue?vue&type=script&lang=js"
import style0 from "./SuppliesDetailView.vue?vue&type=style&index=0&id=f2e8d38c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports